import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Answer from '../answer';
import './answerList.css';
import Button from '../button';
import AnswerResult from '../answerResult';

const AnswerList = props => {
  const {
    answerList,
    onChangeAnswer,
    answer,
    answerValue,
    multipleChoice,
    onChangeAnswerMulti,
    onClickSendAnswer,
    testType
  } = props;

  let singleAnswer = (
    <React.Fragment>
      <ul className="answer-list">
        {answerList !== undefined &&
          answerList.map(item => {
            return (
              <li
                className={`answer-list__item ${
                  answer && testType === 1
                    ? answerValue === item.id
                      ? item.isCorrect
                        ? 'success'
                        : 'error'
                      : ''
                    : ''
                }`}
                key={item.id}
              >
                {!answer ? (
                  <Answer
                    groupName={item.groupName}
                    onChangeAnswer={onChangeAnswer}
                    answerText={item.text}
                    value={item.id}
                    multi={props.multipleChoice}
                  />
                ) : (
                  <AnswerResult
                    testType={props.testType}
                    answerText={item.text}
                    answerComment={item.comment}
                    value={item.id}
                    answerValue={answerValue}
                    answerCorrect={item.isCorrect}
                    answerStatistic={item.percentChoosen}
                  />
                )}
              </li>
            );
          })}
      </ul>
      {answer === true && testType === 1 && (
        <Button
          textButton="Далее"
          onClick={props.onClick}
          classList="question__btn"
        />
      )}
    </React.Fragment>
  );
  let multiAnswer = (
    <React.Fragment>
      <ul className="answer-list">
        {answerList.map(item => {
          return (
            <li
              className={`answer-list__item ${
                answer
                  ? answerValue === item.id
                    ? item.isCorrect
                      ? 'success'
                      : 'error'
                    : ''
                  : ''
              }`}
              key={item.id}
            >
              <Answer
                onChangeAnswer={onChangeAnswerMulti}
                answerText={item.text}
                value={item.id}
                multi={props.multipleChoice}
              />
            </li>
          );
        })}
      </ul>
      {answer === true && (
        <Button
          textButton="Следующий вопрос"
          onClick={props.onClickSendAnswers}
          classList="question__btn"
        />
      )}
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {multipleChoice ? multiAnswer : singleAnswer}
    </React.Fragment>
  );
};

AnswerList.propTypes = {
  answerList: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChangeAnswer: PropTypes.func.isRequired,
  answer: PropTypes.bool.isRequired,
  answerValue: PropTypes.number.isRequired
};

export default AnswerList;
